// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BYz3","title":"styles_title__2TdhS"};